import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";

export class SetCoachAction extends BaseAction<void, string> {

    override async run(): Promise<void | null> {
        try {
            updateRecoilState("selectedCoachAtom", this.params)
        } catch (error) {
            console.error("Error in SetCoachAction:", error);
        }
    }
}

// Create a singleton instance
export const setCoachAction = new SetCoachAction(); 